function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import ReactDOM from 'react-dom';
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import setting from "./setting";
import "./style.less";
import { getPrefixCls } from "../../utils/common";
import { convertMilliseconds } from "../../utils/timeConvsion";
var prefixCls = getPrefixCls('SmCountdown');
var Countdown = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$params, _props$schema, _props$schema$params, _width$split, _width$split$call, _width$split$call$inc, _height$toString, _height$toString$call;
  var positionStyle = props.positionStyle,
    src = props.src,
    _props$showType = props.showType,
    showType = _props$showType === void 0 ? ['day', 'hour', 'minutes', 'second'] : _props$showType,
    _props$width = props.width,
    width = _props$width === void 0 ? '100px' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? '30px' : _props$height,
    title = props.title,
    _props$countTime = props.countTime,
    propsCountTime = _props$countTime === void 0 ? 1 : _props$countTime;
  useImperativeHandle(ref, function () {
    return {};
  });
  var _useState = useState(3600000),
    _useState2 = _slicedToArray(_useState, 2),
    countTime = _useState2[0],
    setCountTime = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    container = _useState4[0],
    setContainer = _useState4[1];
  var source = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.source) || ((_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.source);
  var isDev = source === 'development';
  var sorterConvertedCountTime = convertMilliseconds(countTime).reverse().map(function (item) {
    return (item === null || item === void 0 ? void 0 : item.toString().length) < 2 ? "0".concat(item) : "".concat(item);
  });
  useEffect(function () {
    if (isDev) {
      // b端界面找到绝对定位挂载点
      var node = document.querySelector('.fr-field.w-100.fr-field-complex.fr-field-object:not(.custom-position)');
      setContainer(node);
    }
  }, []);
  useEffect(function () {
    if (isDev) {
      var _document$querySelect;
      // 因为有重复元素，将不需要选中的元素增加custom-position类名
      var newContainer = document.createElement('div');
      newContainer.id = 'customerChild';
      (_document$querySelect = document.querySelector('.field-wrapper.template-wrapper')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.appendChild(newContainer);
      var compsContent = document.querySelectorAll('.field-wrapper.template-wrapper .fr-field.w-100.fr-field-complex.fr-field-object');
      compsContent.forEach(function (item) {
        return item.className = 'fr-field w-100 fr-field-complex fr-field-object custom-position';
      });
    }
  }, []);
  useEffect(function () {
    if (propsCountTime) {
      setCountTime(+propsCountTime * 60 * 60 * 1000);
    }
  }, [propsCountTime]);
  var countCut = function countCut(timer) {
    return setCountTime(function (countTime) {
      if (countTime <= 1000) {
        clearInterval(timer);
        return 0;
      }
      var newCountTime = countTime - 1000;
      return newCountTime;
    });
  };
  useEffect(function () {
    var timer = setInterval(function () {
      countCut(timer);
    }, 1000);
    return function () {
      clearInterval(timer);
    };
  }, []);
  var CountdownComp = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container"),
    style: _objectSpread(_objectSpread({}, positionStyle), {}, {
      backgroundImage: "url(".concat(src, ")"),
      width: width !== null && width !== void 0 && (_width$split = width.split) !== null && _width$split !== void 0 && (_width$split$call = _width$split.call(width, '')) !== null && _width$split$call !== void 0 && (_width$split$call$inc = _width$split$call.includes) !== null && _width$split$call$inc !== void 0 && _width$split$call$inc.call(_width$split$call, '%') ? width : width + 'px',
      height: height !== null && height !== void 0 && (_height$toString = height.toString) !== null && _height$toString !== void 0 && (_height$toString$call = _height$toString.call(height)) !== null && _height$toString$call !== void 0 && _height$toString$call.includes('px') ? height : height + 'px'
    }),
    id: title ? "me-".concat(title) : undefined
  }, (showType === null || showType === void 0 ? void 0 : showType.includes('day')) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-num")
  }, sorterConvertedCountTime[3] || '00'), showType[showType.length - 1] !== 'day' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-spc")
  }, ":")), (showType === null || showType === void 0 ? void 0 : showType.includes('hour')) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-num")
  }, sorterConvertedCountTime[2] || '00'), showType[showType.length - 1] !== 'hour' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-spc")
  }, ":")), (showType === null || showType === void 0 ? void 0 : showType.includes('minutes')) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-num")
  }, sorterConvertedCountTime[1] || '00'), showType[showType.length - 1] !== 'minutes' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-spc")
  }, ":")), (showType === null || showType === void 0 ? void 0 : showType.includes('second')) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-num")
  }, sorterConvertedCountTime[0] || '00'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, isDev && /*#__PURE__*/React.createElement("div", null, "\u5012\u8BA1\u65F6\u7EC4\u4EF6\u5360\u4F4D"), isDev && container ? /*#__PURE__*/ReactDOM.createPortal(CountdownComp, container) : null, !isDev && CountdownComp);
});
var EnhanceCountdown = EnhanceComponent(Countdown);
EnhanceCountdown.settings = setting;
export default EnhanceCountdown;